//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passCesium3DTileClassification = 5.0;\n\
";
